import { Table } from "react-bootstrap";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";
import { ConfirmModal } from "../../../components";
import Product from "./Product";
import api from "../../../api";
import { ICatalog } from "../../../types";

const AllProducts = () => {
  const [catalogs, setCatalogs] = useState<ICatalog[]>([]);
  useEffect(() => {
    api.getAllCatalogs().then((res) => {
      setCatalogs(res);
    });
  }, []);
  return (
    <div className={styles.allProducts}>
      <div className="container">
        <h2 className="title">ВСЕ ДЕТАЛИ</h2>
        <div className={styles.table}>
          <Table striped>
            <thead>
              <tr>
                <th>Тип каталога</th>
                <th>Стоимость</th>
                <th>Описание</th>
                <th>Фотография</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {catalogs.map((e) => (
                <Product
                  desc={e.description}
                  img={e.image.imagePath}
                  price={e.price}
                  title={e.catalogName}
                  key={e.catalogId}
                />
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default AllProducts;
